/*
  TMA — quantity stepper on the product page.

  The number input is real and editable on its own, so the control works with a
  keyboard, with assistive tech, and if this script never loads. All this does
  is wire the − and + buttons to it and keep the value sane.

  It also nudges the bundle hint once the quantity reaches the threshold, so
  the "get 5 or more, save 10%" promise is confirmed at the moment the shopper
  actually qualifies rather than only being advertised elsewhere.
*/
(function () {
  var THRESHOLD = 5;

  document.querySelectorAll('[data-tma-qty]').forEach(function (group) {
    var input = group.querySelector('input[name="quantity"]');
    if (!input) return;

    var form = group.closest('form');
    var hint = form && form.querySelector('[data-tma-qty-hint]');
    var hintText = hint && hint.textContent;

    function clamp(n) {
      if (isNaN(n) || n < 1) return 1;
      return Math.min(n, 99);
    }

    function sync() {
      var n = clamp(parseInt(input.value, 10));
      input.value = n;
      /* the minus button is meaningless at one */
      var minus = group.querySelector('[data-qty-step="-1"]');
      if (minus) minus.disabled = n <= 1;
      if (hint) {
        hint.textContent = n >= THRESHOLD
          ? '10% comes off this order automatically.'
          : hintText;
        hint.classList.toggle('is-met', n >= THRESHOLD);
      }
    }

    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      input.value = clamp(parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-step'), 10));
      sync();
    });

    input.addEventListener('change', sync);
    input.addEventListener('blur', sync);
    sync();
  });
})();
